<div
    [ngClass]="{
        'environment-settings-container': statusPanelOpen,
        hidden: responsive.isSmall() && !statusPanelOpen,
    }"
>
    <div class="status-pannel">
        <img
            data-cy="header-status-alarm-icon"
            style="display: block"
            [src]="
                statusAlarm
                    ? 'assets/icons/status-alarm-good.svg'
                    : 'assets/icons/status-alarm-bad.svg'
            "
        />
        <img
            data-cy="header-status-maitenance-icon"
            style="display: block"
            [src]="
                statusMaintenance
                    ? 'assets/icons/status-maintenance-good.svg'
                    : 'assets/icons/status-maintenance-bad.svg'
            "
        />
    </div>
</div>

<img
    class="material-symbols-outlined"
    style="display: block"
    [src]="statusPanelIcon"
    *ngIf="responsive.isSmall()"
    (click)="showStatusPanel()"
/>

<div
    #envSettingsPanel
    class="environment-settings-container"
    [ngClass]="{
        hidden: !isEnvironmentSettingOpen(),
    }"
>
    <div class="languages">
        <button
            data-cy="header-en-icon"
            [ngClass]="{
                'language-button': true,
                'language-button-active': currentLang == 'EN',
            }"
            (click)="setLanguage('EN')"
            data-testid="en"
        >
            EN
        </button>
        <button
            data-cy="header-jp-icon"
            [ngClass]="{
                'language-button': true,
                'language-button-active': currentLang == 'JP',
            }"
            (click)="setLanguage('JP')"
            data-testid="jp"
        >
            JP
        </button>
    </div>
    <div class="brightness">
        <mat-icon data-cy="header-day-night-icon" svgIcon="leading"></mat-icon>
    </div>
</div>
